module.exports = __webpack_public_path__ + "images/smartcredit-79d66fda.png";